import { getShopperId } from '../util/auth';
import { vatInvoiceAvailableError } from './trackingApi';
import { trackVatInvoiceAvailableFetchError } from './newRelicTrackingApi';
import { dispatchGetRequest } from '../util/apiUtils.ts';

const stagingVatInvoiceBaseUrl = process.env.STAGING_VAT_INVOICE_BASE_URL;
const prodVatInvoiceBaseUrl = process.env.PRODUCTION_VAT_INVOICE_BASE_URL;

/**
 * Returns an object containing parameters to use for calling the VIG service.
 * In the future, consider adding timeouts as part of the configuration.
 * @param {*} environment The environment to send VIG service requests too.
 */
const getConfigForEnvironment = environment => {
  if (!environment) {
    console.error(
      `Unable to derive service config for a null/empty environment, using STAGING environment as sensible fallback.`
    );
    return { baseUrl: stagingVatInvoiceBaseUrl };
  }
  switch (environment) {
    case 'PRODUCTION':
      return { baseUrl: prodVatInvoiceBaseUrl };
    case 'STAGING':
      return { baseUrl: stagingVatInvoiceBaseUrl };
    default:
      console.warn(
        `Unsupported environment type of ${environment}, using STAGING envirnoment as sensible fallback.`
      );
      return { baseUrl: stagingVatInvoiceBaseUrl };
  }
};

export const getVatInvoices = async ({ orderNumber, environment }) => {
  const { baseUrl } = getConfigForEnvironment(environment);
  const shopperId = getShopperId();
  const url = `${baseUrl}/invoices/shopper/${shopperId}/order/${orderNumber}/pdf`;

  const response = await dispatchGetRequest({ url });
  return response;
};

export const getAnonVatInvoices = async ({ order, environment }) => {
  const { orderNumber, emailAddress } = order;
  const { baseUrl } = getConfigForEnvironment(environment);

  const url = `${baseUrl}/invoices/email/${emailAddress}/order/${orderNumber}/pdf`;
  const response = await dispatchGetRequest({ url });
  return response;
};

export const getVatInvoiceAvailable = async ({ order, environment }) => {
  const { orderNumber, emailAddress, orderPlacedAnonymously, tenantId } = order;
  const { baseUrl } = getConfigForEnvironment(environment);
  const shopperId = getShopperId();
  const url = orderPlacedAnonymously
    ? `${baseUrl}/invoices/email/${emailAddress}/order/${orderNumber}/exists`
    : `${baseUrl}/invoices/shopper/${shopperId}/order/${orderNumber}/exists`;

  try {
    const response = await dispatchGetRequest({ url });
    const { invoiceAvailable } = await response.json();
    return invoiceAvailable;
  } catch (err) {
    const metricsAdditionalData = {
      orderNumber,
      tenantId,
      orderPlacedAnonymously,
      shopperId,
    };
    // notify segment for analytics
    vatInvoiceAvailableError(metricsAdditionalData);

    // notify NR for tracking/monitoring
    trackVatInvoiceAvailableFetchError(metricsAdditionalData, err);
    return false;
  }
};
